export const BreedsStatesMap = {
  STARTED: 'started',
  DOWNLOADING_BREEDS: 'downloading_breeds',
  SAVING_UNMATCHED_BREEDS: 'saving_unmatched_breeds',
  COMPLETED: 'completed',
  RESOLVED: 'resolved',
  BREEDS_UPLOADED: 'breeds_uploaded'
};
